// March 18th icon update
// Expertise Contents Icons
import BrandStrategyTracking from "../icons/images/brandStrategyTracking-01.png";
import CampaignEffectiveness from "../icons/images/campaignEffectiveness-01.png";
import CampaignTracking from "../icons/images/campaignTracking-01.png";
import ContentTesting from "../icons/images/contentTesting-01.png";
import CreativeMaterialsTesting from "../icons/images/creativeMaterialsTesting-01.png";
import FranchiseManagement from "../icons/images/franchiseManagement-01.png";
import MarketingandAudiencelandscaping from "../icons/images/marketingandAudiencelandscaping-01.png";
import NextGen from "../icons/images/nextGen-01.png";
import Positioning from "../icons/images/positioning-01.png";
import PositioningPlatformsOptimization from "../icons/images/positioningPlatformsOptimization-01.png";
import SegmentationTargeting from "../icons/images/segmentationTargeting-01.png";
import Strategy from "../icons/images/strategy-01.png";
import UxTesting from "../icons/images/uxtesting-01.png";

// Expertise Logos
import LogoAmazon from "../icons/images/logo-amazon-video.png";
import LogoDisney from "../icons/images/logo-disney.png";
import LogoHulu from "../icons/images/logo-hulu.png";
import LogoSony from "../icons/images/logo-sony.png";

const getImgIcon = (iconName) => {
    switch (iconName) {
        case 'brand-strategy-tracking':
            return BrandStrategyTracking;
        case 'campaign-effectiveness':
            return CampaignEffectiveness;
        case 'campaign-tracking':
            return CampaignTracking;
        case 'content-testing':
            return ContentTesting;
        case 'creative-materials-testing':
            return CreativeMaterialsTesting;
        case 'franchise-management':
            return FranchiseManagement;
        case 'marketing-and-audience-landscaping':
            return MarketingandAudiencelandscaping;
        case 'next-gen':
            return NextGen;
        case 'positioning':
            return Positioning;
        case 'positioning-platforms-optimization':
            return PositioningPlatformsOptimization;
        case 'segmentation-targeting':
            return SegmentationTargeting;
        case 'strategy':
            return Strategy;
        case 'ux-testing':
            return UxTesting;
        case 'logo-amazon-video':
            return LogoAmazon;
        case 'logo-disney':
            return LogoDisney;
        case 'logo-hulu':
            return LogoHulu;
        case 'logo-sony':
            return LogoSony;
        default:
            return BrandStrategyTracking;
    }
}

export default getImgIcon;
